import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Alert } from '@mui/material';
import billingApi from '../services/billingApi';

export default function DiscountCodeInput({ planId, onApplied }) {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [discount, setDiscount] = useState(null);

  const handleValidate = async () => {
    if (!code.trim()) return;
    setLoading(true);
    setError('');

    try {
      const result = await billingApi.post('/api/discounts/validate', { code: code.trim(), planId });
      setDiscount(result.discount);
      if (onApplied) onApplied(result.discount, code.trim());
    } catch (err) {
      setError(err.message);
      setDiscount(null);
      if (onApplied) onApplied(null, '');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
        <TextField
          size="small"
          label="Discount code"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          disabled={loading}
          sx={{ flexGrow: 1 }}
        />
        <Button
          variant="outlined"
          onClick={handleValidate}
          disabled={loading || !code.trim()}
        >
          Apply
        </Button>
      </Box>
      {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
      {discount && (
        <Alert severity="success" sx={{ mt: 1 }}>
          {discount.description || `${discount.discount_type}: ${discount.discount_value}${discount.discount_type === 'percentage' ? '%' : ''} off`}
          {discount.final_price_cents !== undefined && (
            <Typography variant="body2">
              New price: ${(discount.final_price_cents / 100).toFixed(2)}
            </Typography>
          )}
        </Alert>
      )}
    </Box>
  );
}
